import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";

const styles = () => ({
  root: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

/**
 * Salesforceの連携が失効している場合のコンポーネント
 */
class SalesforceIntegrateExpire extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root} style={{ minHeight: "unset" }}>
        <Typography variant="subheading">
          認証情報が失効しています。
          <a
            href={
              process.env.REACT_APP_API_BASE_URL +
              "/oauth2/salesforce?redirect_url=" +
              process.env.REACT_APP_FRONTEND_URL +
              "/setting/integrations/salesforce"
            }
            target="_self"
            className={classes.link}
          >
            こちら
          </a>
          より再設定してください。
        </Typography>
      </div>
    );
  }
}

SalesforceIntegrateExpire.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SalesforceIntegrateExpire);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/SalesforceIntegrateExpire.jsx